<template>
    <div>

        <v-data-table :loading="loading" :search="search" disable-initial-sort :rows-per-page-items="rowPerPage"
            :headers="headers" :items="filtered_items" item-key="id">
            <template #headers="props">
                <tr>
                    <th :class="['fw-bold', `text-xs-${header.align}`]" v-for="header in props.headers"
                        :key="header.text">
                        {{ header.text }}
                    </th>
                </tr>
            </template>
            <template #items="props">
                <tr>
                    <td class="text-center text-no-wrap">{{ props.index + 1 | }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.repairRequest.registration_date |
                        formatTimeServer }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.receipt_id }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.repairman_name }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.room_id }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.repairRequest.content }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.completion_date | formatTimeServer }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.completion_time }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.labor_cost | formatCurrency }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.material_purchased }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.material_cost | formatCurrency }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.total_payment | formatCurrency }}</td>
                    <td class="text-center text-no-wrap">{{ props.item.status }}</td>
                </tr>
            </template>
            <template #no-data>
                Chưa có thông tin
            </template>
        </v-data-table>
        <export-csv-button :trigger="export_csv.trigger" :title="export_csv.title"
            :rows="export_csv.rows"></export-csv-button>
    </div>
</template>

<script>

import ExportCsvButton from 'Components/ExportExcel/ExportCsvButton';
import { buildParamQuery, formatTimeServer, formatCurrency } from 'Helpers';
import api from '../../api';

export default {
    name: "table-cham-cong",
    props: {
        reload_table: Number,
        download_csv_count: Number,
        loader: Boolean,
        date_start: String,
        date_end: String,
        search: String,
        repairman_name: String,
        repair_timesheet_status: String
    },
    components: {
        ExportCsvButton
    },
    data() {
        return {
            items: [],
            loading: false,
            headers: [
                { text: "Số thứ tự", align: "center", sortable: true },
                { text: "Ngày đăng ký sửa chữa", align: "center", sortable: true, value: "repairRequest.registration_date" },
                { text: "Mã chứng từ", align: "center", sortable: true, value: "receipt_id" },
                { text: "Thợ sửa", align: "center", sortable: true, value: "repairman_name" },
                { text: "Phòng", align: "center", sortable: true, value: "room_id" },
                { text: "Nội dung", align: "center", sortable: true, value: "repairRequest.content" },
                { text: "Ngày hoàn thành", align: "center", sortable: true, value: "completion_date" },
                { text: "Thời gian hoàn thành", align: "center", sortable: true, value: "completion_time" },
                { text: "Tiền công", align: "center", sortable: true, value: "labor_cost" },
                { text: "Mua vật tư", align: "center", sortable: true, value: "material_purchased" },
                { text: "Tiền vật tư", align: "center", sortable: false, value: "material_cost" },
                { text: "Tổng phải thanh toán", align: "center", sortable: true, value: "total_payment" },
                { text: "Trạng thái", align: "center", sortable: true, value: "status" },
            ],
            rowPerPage: [50, 100, 200, { "text": "Tất cả", "value": -1 }],
            trigger_edit_component: false,
            export_csv: {
                trigger: false,
                title: "",
                rows: []
            },
            formatCurrency
        }
    },
    mounted() {
        this.getData();
    },
    computed: {
        filtered_items() {
            return this.items.filter(item => {
                const matchRepairman =
                    (this.repairman_name === "Tất cả") ||
                    (this.repairman_name && item.repairman_name === this.repairman_name);

                const matchStatus =
                    (this.repair_timesheet_status === "Tất cả") ||
                    (this.repair_timesheet_status && item.status === this.repair_timesheet_status);

                return matchRepairman && matchStatus;
            });
        }
    },
    watch: {
        reload_table() {
            this.getData()
        },
        loading(nv) {
            this.$emit("update:loader", nv)
        },
        download_csv_count() {
            this.exportCSV()
        }
    },
    methods: {
        getData: async function () {
            this.items = []
            this.loading = true;
            const params = {
                dateStart: this.date_start,
                dateEnd: this.date_end
            }
            const query = buildParamQuery(params)
            let data = await api.getRepairTimesheetsWithRepairRequest(query)
            this.loading = false;
            if (data.status === 200) {
                this.items = data.data.map(item => {
                    item.repairRequest.registration_date = item.repairRequest.registration_date.substring(0, 10)
                    return item
                })
            } else {
                console.log('Lỗi lúc tải danh sách chấm công sửa chữa');
            }
        },
        exportCSV: function () {
            const rows = this.filtered_items.map((item, index) => {
                const req = item.repairRequest || {};

                return {
                    "Số thứ tự": index + 1,
                    "Ngày đăng ký sửa chữa": req.registration_date
                        ? formatTimeServer(req.registration_date)
                        : "",
                    "Mã chứng từ": item.receipt_id,
                    "Thợ sửa": item.repairman_name,
                    "Phòng": item.room_id,
                    "Nội dung": req.content || "",
                    "Ngày hoàn thành": item.completion_date
                        ? formatTimeServer(item.completion_date)
                        : "",
                    "Thời gian hoàn thành": item.completion_time || "",
                    "Tiền công": item.labor_cost || "",
                    "Mua vật tư": item.material_purchased || "",
                    "Tiền vật tư": item.material_cost || "",
                    "Tổng phải thanh toán": item.total_payment || "",
                    "Trạng thái": item.status || ""
                };
            });

            this.export_csv.rows = rows;
            const date = new Date().toISOString().substr(0, 10);
            this.export_csv.title = `cham-cong-${date}`;
            this.export_csv.trigger = !this.export_csv.trigger;
        }
    }
}
</script>

<style scoped>
.v-list__tile__action {
    min-width: 30px;
}
</style>